import { DEPLOY_WITH_LICENSE, EXTERNAL_DEPLOY, SAAS } from '@/config/constant';
export const hasLocalBackupComponentHub = () => !!DEPLOY_WITH_LICENSE;
export const isExternalDeploy = () => !!EXTERNAL_DEPLOY;
export const isSaas = () => !!SAAS;
